import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { usePostHog } from "@/analytics/usePostHog";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/brand/BrandButton";
import { localizePath } from "@/lib/localeRoutes";
import { useAppUrl } from "@/hooks/useAppUrl";

export const DoctorVisitsFinalCta = () => {
  const { t, i18n } = useTranslation("doctorVisits");
  const posthog = usePostHog();
  const bookingUrl = useAppUrl();

  return (
    <section id="request-visit" tabIndex={-1} className="px-4 pb-20 sm:px-6 sm:pb-24 lg:px-8">
      <div className="mx-auto max-w-[1168px] overflow-hidden rounded-3xl bg-secondary px-6 py-12 text-secondary-foreground sm:px-10 sm:py-14 lg:flex lg:items-end lg:justify-between lg:gap-16 lg:px-14">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.16em] text-primary">
            {t("finalCta.eyebrow")}
          </p>
          <h2 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            {t("finalCta.title")}
          </h2>
          <p className="mt-4 text-lg leading-8 text-secondary-foreground/70">
            {t("finalCta.description")}
          </p>
        </div>

        <div className="mt-8 flex shrink-0 flex-col gap-3 sm:flex-row lg:mt-0 lg:flex-col">
          <Button
            size="lg"
            className="h-12 rounded-xl px-7 text-base sm:h-14"
            asChild
          >
            <a
              href={bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                posthog?.capture("cta_clicked", {
                  location: "doctor_visits_final",
                  cta_type: "book_visit",
                  service: "doctor_visits",
                })
              }
            >
              {t("finalCta.primaryCta")}
              <ArrowRight aria-hidden="true" />
            </a>
          </Button>
          <Link
            to={localizePath("/contact", i18n.language)}
            className="inline-flex min-h-11 items-center justify-center rounded-xl px-5 font-semibold text-secondary-foreground underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            onClick={() =>
              posthog?.capture("cta_clicked", {
                location: "doctor_visits_final",
                cta_type: "contact",
                service: "doctor_visits",
              })
            }
          >
            {t("finalCta.contactLink")}
          </Link>
        </div>
      </div>
    </section>
  );
};
